import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 7, viewBox: "0 0 13 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 1L6.125 6L11.75 1", stroke: "black", strokeWidth: 1.5 }));
export default SvgArrowDown;
